import React, { Component } from "react";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import { Col, Container, Row, Button } from "react-bootstrap";
import * as Cookies from "es-cookie";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import gql from "graphql-tag";
import '../institute_revision_material/_instRevisionMaterial.scss'
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import RevisionMaterialUploadModal from "./RevisionMaterialUploadModal";
import MaterialPDFViewModal from "./MaterialPDFViewModal";
import { RevisionMaterialShimmer, RevisionTableShimmer } from "./RevisionMaterialShimmer";


const DELETE_REVISION_MATERIAL = gql`
   mutation($revisionMaterialId:ID){
    deleteRevisionMaterial(revisionMaterialId:$revisionMaterialId)
    }
 `;

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

const GET_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_ACADEMIC_YEARS = gql`
  query getAcademicYears($id: Int) {
    getAcademicYears(id: $id) {
      id
      academic_year
    }
  }
`;

const GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR = gql`
  query getClassSubjectsByAcademicYear(
    $academic_year_id: Int!
    $classIds: String
    $institute_id: Int!
  ) {
    getClassSubjectsByAcademicYear(
      academic_year_id: $academic_year_id
      classIds: $classIds
      institute_id: $institute_id
    ) {
      class_id
      checked
      subject_ids
      subject_names
    }
  }
`;

const GET_INSTITUTE_REVISION_MATERIAL = gql`
  query($institute_id:Int!, $branch_id:Int!, $exam_id:String, $class_id:String, $subject_id:String, $chapter_id:String, $inserted_by:Int){
    getInstituteRevisionMaterial(institute_id: $institute_id, branch_id:$branch_id, exam_id:$exam_id, class_id:$class_id, subject_id:$subject_id, chapter_id:$chapter_id, inserted_by:$inserted_by) {
      id
      branch_id
      branch_name
      exam_id
      exam_name
      class_id
      class_name
      subject_id
      subject_name
      chapter_id
      chapter_name
      file_name
      file_path
      inserted_by
      inserted_time
    }
  }
`;

// ── Finance-style multi-select checkbox dropdown ──────────────────────────────
class CheckboxDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }
    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
    handleOutside = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false });
    };
    toggle = (id) => {
        const { value, onChange } = this.props;
        const exists = value.includes(id);
        onChange(exists ? value.filter((v) => v !== id) : [...value, id]);
    };
    render() {
        const { options, value, placeholder, onChange } = this.props;
        const { open } = this.state;
        const label = value.length === 0
            ? placeholder
            : value.length === options.length
                ? `All (${options.length})`
                : value.length === 1
                    ? options.find((o) => o.value === value[0])?.label || `${value.length} selected`
                    : `${value.length} selected`;
        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => this.setState({ open: !open })}
                    style={{ borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none", height: 42 }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 240, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (
                            <>
                                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))}
                                    style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                    <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                                    Select All
                                </div>
                                {options.map((o) => (
                                    <div key={o.value} onClick={() => this.toggle(o.value)}
                                        style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                        <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                        <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

// Design system mirrors the finance module's tabbed pages (see FeeStructureHome.jsx /
// ExpenseManagementMain.jsx) — gradient page background, white card shell, and a
// hand-rolled Bootstrap nav-tabs strip with the "cutout" active-tab treatment — plus
// AccountsLedger.jsx's inline content styling (labels/inputs, pill count badge, empty state).
const FIN = {
    pageWrap: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
    card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
    tabStrip: { background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px", borderRadius: "16px 16px 0 0" },
    content: { padding: 28 },
    label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" },
    select: { borderRadius: 8, border: "1px solid #e5e7eb", padding: "8px 12px", fontSize: 13, fontWeight: 600, color: "#1f2937", background: "#fff", width: "100%", height: 40 },
    err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
    countBadge: { background: "#eff6ff", color: "#6366f1", borderRadius: 20, padding: "4px 14px", fontSize: 12, fontWeight: 700, border: "1px solid #c7d2fe" },
};

// Exact tab-link recipe from FeeStructureHome.jsx / ExpenseManagementMain.jsx — the
// active tab's border color fakes a "cutout" (#e2e8f0 #e2e8f0 #fff) that visually merges
// into the white content panel below it.
const tabLinkStyle = (isActive) => ({
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "12px 20px",
    color: isActive ? "#6366f1" : "#4b5563",
    background: isActive ? "#fff" : "transparent",
    borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
    borderWidth: "1.5px",
    borderBottomWidth: isActive ? "2px" : "1.5px",
    borderRadius: "10px 10px 0 0",
    transition: "all 0.15s ease",
    marginBottom: "-1.5px",
    textDecoration: "none",
});

class RevisionMaterialSection extends Component {
    constructor() {
        super();
        this.state = {
            branches: [],
            getClasses: [],
            academicYears: [],
            branchSearch: "0",
            branchError: "",
            examSearch: [],
            classSearch: [],
            classMultiError: "",
            subjectSearch: [],
            subjectMultiError: "",
            classWiseSubjects: [],
            chapterSearch: [],
            instituteRevisionMaterialData: [],
            activeTab: "dashboard",
            materialViewModal: false,
            noDataError: "",
            loader: 0,
            individualMaterials: [],
            initialLoad: true
        }
    }

    async componentDidMount() {
        try {
            // getAcademicYears is a global list (academic_year has no institute_id column),
            // so a class_subjects row can be tied to an older year than the newest one —
            // keep the full list rather than just the latest so class-wise filtering (used
            // once the user picks a class, see onClassChange) can try each.
            const [branchesRes, classesRes, acadRes] = await Promise.all([
                this.props.client.query({ query: GET_BRANCHES, variables: { institution_id: parseInt(Cookies.get("institutionid")) }, fetchPolicy: "network-only" }),
                this.props.client.query({ query: GET_CLASSES, variables: { id: 1 }, fetchPolicy: "network-only" }),
                this.props.client.query({ query: GET_ACADEMIC_YEARS, variables: { id: parseInt(Cookies.get("institutionid")) }, fetchPolicy: "network-only" })
                    .catch(err => { console.warn("Could not query academic years — class-wise subject filtering will fall back to the institute-wide subject list.", err); return { data: { getAcademicYears: [] } }; }),
            ]);
            // The header's branch selection (NavbarOne) IS this page's branch filter.
            const branches = scopeBranches(branchesRes.data.getBranches || []);
            const getClasses = classesRes.data.getExamClasses || [];
            const academicYears = acadRes.data?.getAcademicYears || [];
            this.setState({ branches, getClasses, academicYears, initialLoad: false }, () => this.initDefaults());
            // Re-scope whenever the header's branch selection changes.
            if (!this.offBranchScope) this.offBranchScope = onBranchScopeChange(() => this.reloadBranchScope());
        } catch (err) {
            console.error("revision material load error", err);
            this.setState({ initialLoad: false });
        }
    }

    // ── option builders ──────────────────────────────────────────────
    classOptionsForBranch = (branchId) => {
        const b = this.state.branches.find(x => String(x.id) === String(branchId));
        const sections = b ? (b.sections || []) : [];
        const classIds = [...new Set(sections.map(s => Number(s.class_id)))];
        const options = classIds
            .map(cid => this.state.getClasses.find(c => c.id === cid))
            .filter(Boolean)
            .map(c => ({ value: c.id, label: c.class }));
        return this.filterClassesForEmployee(options);
    };

    // The employee row for the logged-in staff member, or null. getEmployees is scoped to
    // institute_id + branch_id server-side, so a branch_id cookie that disagrees with the
    // employee's own branch returns nothing — hence callers must treat null as "restrict",
    // never as "unrestricted" (see the fail-closed note below).
    loggedInEmployee = () => {
        const match = (this.props.getEmployees || []).filter((item) => item.employee_id == Cookies.get("id"));
        return match.length > 0 ? match[0] : null;
    };

    // Is this a staff login? Only userlevel 3 is restricted to assigned classes/subjects;
    // a main institute login (userlevel 1/2) is unrestricted and sees everything.
    isEmployeeLogin = () => Cookies.get("userlevel") == 3;

    // Restrict a class list to the ones a userlevel-3 employee is assigned to (via
    // employee.class_ids, same comma-separated convention as subject_ids).
    filterClassesForEmployee = (list) => {
        if (!this.isEmployeeLogin()) return list;
        const employee = this.loggedInEmployee();
        // Fail CLOSED: an unresolvable employee used to skip the filter entirely and hand a
        // staff login every class in the institute. Showing nothing is the safe direction —
        // it's visibly broken rather than silently over-permissive.
        if (!employee) {
            console.warn(`No employee row matched id=${Cookies.get("id")} in branch=${Cookies.get("branch_id")} — hiding all classes rather than showing every class.`);
            return [];
        }
        const allowed = new Set((employee.class_ids || "").split(",").map(s => s.trim()).filter(Boolean));
        return list.filter(o => allowed.has(String(o.value)));
    };

    // Restrict a subject list to the ones a userlevel-3 employee is assigned to. "General"
    // (0) is not an assignable subject and always stays available.
    filterForEmployee = (list) => {
        const dedupe = (l) => {
            const seen = new Set();
            return l.filter(o => (seen.has(o.value) ? false : (seen.add(o.value), true)));
        };
        if (!this.isEmployeeLogin()) return dedupe(list);
        const employee = this.loggedInEmployee();
        // Fail closed, same reasoning as filterClassesForEmployee.
        if (!employee) {
            console.warn(`No employee row matched id=${Cookies.get("id")} in branch=${Cookies.get("branch_id")} — restricting subjects to General.`);
            return dedupe(list.filter(o => o.value === 0));
        }
        const allowed = new Set((employee.subject_ids || "").split(",").map(s => s.trim()).filter(Boolean));
        return dedupe(list.filter(o => o.value === 0 || allowed.has(String(o.value))));
    };

    // Institute-wide subject list — used as a fallback when no class is selected yet or
    // class-wise data isn't available (mirrors RevisionMaterialUploadModal).
    subjectOptions = () => {
        let list = [{ value: 0, label: "General" }];
        const offlineSubjects = this.props.globals.offlineExamSubjects || [];
        offlineSubjects.forEach(item => list.push({ value: item.id, label: item.subject }));
        return this.filterForEmployee(list);
    };

    // Class-wise subjects via getClassSubjectsByAcademicYear (same query the upload modal
    // uses), unioned across every selected class and every academic year — this is a filter
    // dropdown, so broader inclusion here is fine (unlike the modal, it stays scoped to the
    // classes actually selected).
    fetchSubjectsForClasses = async (classIds) => {
        const { academicYears } = this.state;
        if (!classIds || classIds.length === 0 || academicYears.length === 0) {
            return this.subjectOptions();
        }
        const parseCsv = (val) => String(val || "").split(",").map(s => s.trim()).filter(Boolean);
        const isChecked = (v) => ["true", "1"].includes(String(v ?? "").trim().toLowerCase());
        let list = [{ value: 0, label: "General" }];
        const seen = new Set([0]);
        try {
            for (const year of academicYears) {
                const res = await this.props.client.query({
                    query: GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR,
                    variables: {
                        academic_year_id: parseInt(year.id),
                        classIds: classIds.join(","),
                        institute_id: parseInt(Cookies.get("institutionid")),
                    },
                    fetchPolicy: "network-only",
                });
                const rows = res.data?.getClassSubjectsByAcademicYear || [];
                rows.forEach(row => {
                    if (!row || !row.subject_ids) return;
                    const ids = parseCsv(row.subject_ids);
                    const names = parseCsv(row.subject_names);
                    const checked = parseCsv(row.checked);
                    ids.forEach((id, idx) => {
                        const numId = parseInt(id, 10);
                        if (checked.length && isChecked(checked[idx]) && !seen.has(numId)) {
                            seen.add(numId);
                            list.push({ value: numId, label: names[idx] || id });
                        }
                    });
                });
            }
        } catch (err) {
            console.warn("Class-wise subjects fetch failed for filter.", err);
        }
        return this.filterForEmployee(list);
    };

    chapterOptionsFor = (subjectIds, classIds) => {
        const out = [];
        const seen = new Set();
        (subjectIds || []).forEach(sid => {
            if (sid == 0) return; // "General" has no chapters
            const subj = (this.props.globals.subjects || []).find(s => +s.id === +sid);
            if (!subj) return;
            (subj.chapters || [])
                .filter(ch => (classIds || []).map(Number).includes(Number(ch.class)))
                .forEach(ch => {
                    if (!seen.has(ch.id)) { seen.add(ch.id); out.push({ value: ch.id, label: ch.chapter }); }
                });
        });
        return out;
    };

    // "Others" (value 0) is a real filter option, not a placeholder — Exam is optional on
    // upload, so a material can be saved with exam_id NULL. Selecting it maps to
    // `irm.exam_id IS NULL` in the resolver; without it those materials became unreachable
    // the moment the filter was narrowed to a subset (NULL never matches `IN (...)`).
    // Real exam ids start at 1 (see the chapter-table branch on `exam_id IN (1, 2)` in the
    // resolver), so 0 is free to use as the sentinel.
    examOptions = () => [
        { value: 0, label: "Others" },
        ...(this.props.globals.exams || []).map(e => ({ value: e.id, label: e.exam })),
    ];

    // Default view (initial load / branch change) intentionally uses the institute-wide
    // subject list, NOT the class-wise fetch — class_subjects config can be incomplete for
    // some classes (e.g. missing a mapping entirely), and scoping the default selection to
    // it would silently hide real uploaded materials that don't match that config. Class-wise
    // narrowing only happens when the user explicitly changes the Class filter (onClassChange).
    initDefaults = () => {
        const { branches } = this.state;
        if (branches.length === 0) return;
        const branchId = branches[0].id;
        const classIds = this.classOptionsForBranch(branchId).map(o => o.value);
        const classWiseSubjects = this.subjectOptions();
        const subjectIds = classWiseSubjects.map(o => o.value);
        const chapterIds = this.chapterOptionsFor(subjectIds, classIds).map(o => o.value);
        this.setState({
            branchSearch: branchId,
            // All exams selected by default (see getInstituteRevisionMaterial, which treats
            // "every option selected" the same as no filter) — Exam is optional on upload, so
            // defaulting to a specific exam here would hide every material saved without one,
            // the same class of bug fixed for Class/Subject above.
            examSearch: this.examOptions().map(o => o.value),
            classSearch: classIds,
            classWiseSubjects,
            subjectSearch: subjectIds,
            chapterSearch: chapterIds,
        }, () => this.getInstituteRevisionMaterial());
    };

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // The header changed its branch selection → refetch the branch list through
    // scopeBranches() and re-seed every dependent filter.
    reloadBranchScope = async () => {
        try {
            const res = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            this.setState({ branches: scopeBranches(res.data.getBranches || []) }, () => this.initDefaults());
        } catch (err) {
            console.error("revision material branch re-scope error", err);
        }
    };

    // ── change handlers (each triggers a live re-fetch — no "Get Materials" button) ──
    onBranchChange = (branchId) => {
        if (branchId === "0") { this.setState({ branchSearch: "0" }); return; }
        const classIds = this.classOptionsForBranch(branchId).map(o => o.value);
        const classWiseSubjects = this.subjectOptions();
        const subjectIds = classWiseSubjects.map(o => o.value);
        const chapterIds = this.chapterOptionsFor(subjectIds, classIds).map(o => o.value);
        this.setState({
            branchSearch: branchId,
            classSearch: classIds,
            classWiseSubjects,
            subjectSearch: subjectIds,
            chapterSearch: chapterIds,
            branchError: "", classMultiError: "", subjectMultiError: "",
            instituteRevisionMaterialData: [], noDataError: "", loader: 1,
        }, () => this.getInstituteRevisionMaterial());
    };

    onExamChange = (examIds) => {
        this.setState({ examSearch: examIds, instituteRevisionMaterialData: [], noDataError: "", loader: 1 }, () => this.getInstituteRevisionMaterial());
    };

    onClassChange = async (classIds) => {
        // Refresh the Subject dropdown for the newly selected class(es) and select all of
        // them by default, same as onBranchChange — don't try to preserve the prior subject
        // selection, since it was scoped to the old class(es) and may no longer apply.
        this.setState({ classSearch: classIds, classMultiError: "", instituteRevisionMaterialData: [], noDataError: "", loader: 1 });
        const classWiseSubjects = await this.fetchSubjectsForClasses(classIds);
        const subjectIds = classWiseSubjects.map(o => o.value);
        const chapterIds = this.chapterOptionsFor(subjectIds, classIds).map(o => o.value);
        this.setState({ classWiseSubjects, subjectSearch: subjectIds, chapterSearch: chapterIds }, () => this.getInstituteRevisionMaterial());
    };

    onSubjectChange = (subjectIds) => {
        const chapterIds = this.chapterOptionsFor(subjectIds, this.state.classSearch).map(o => o.value);
        this.setState({ subjectSearch: subjectIds, chapterSearch: chapterIds, subjectMultiError: "", instituteRevisionMaterialData: [], noDataError: "", loader: 1 }, () => this.getInstituteRevisionMaterial());
    };

    getInstituteRevisionMaterial = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_INSTITUTE_REVISION_MATERIAL,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: parseInt(this.state.branchSearch),
                    // Every option selected (the default) is treated the same as no filter —
                    // "all exams + Others" already means "everything", so this just skips a
                    // redundant WHERE clause. Any narrower selection is sent as-is, including
                    // the "Others" sentinel (0), which the resolver maps to `exam_id IS NULL`.
                    exam_id: this.state.examSearch.length > 0 && this.state.examSearch.length < this.examOptions().length
                        ? this.state.examSearch.join(",")
                        : null,
                    class_id: this.state.classSearch.join(","),
                    subject_id: this.state.subjectSearch.join(","),
                    chapter_id: this.state.chapterSearch.join(","),
                    // Staff (userlevel 3) only ever see materials they personally uploaded;
                    // the main institute login (1/2) sees everything for the branch.
                    inserted_by: Cookies.get("userlevel") == 3 ? parseInt(Cookies.get("id")) : null,
                },
                fetchPolicy: 'network-only'
            });
            const data = result.data.getInstituteRevisionMaterial || [];
            if (data.length > 0) {
                this.setState({ instituteRevisionMaterialData: data, loader: 0, noDataError: "" });
            } else {
                this.setState({ loader: 0, instituteRevisionMaterialData: [], noDataError: "No Material Available" });
            }
        } catch (err) {
            console.error("getInstituteRevisionMaterial error", err);
            this.setState({ loader: 0, instituteRevisionMaterialData: [], noDataError: "No Material Available" });
        }
    };

    articlecolumns = [
        { dataField: "class", text: "Class", sort: true },
        { dataField: "subject", text: "Subject", sort: true },
        { dataField: "chapter", text: "Chapter", sort: true },
        { dataField: "file_name", text: "Material Name" },
        { dataField: "uploaded", text: "Uploaded", sort: true },
        { dataField: "Actions", formatter: this.ActionsFun.bind(this), text: "Actions" },
    ];

    // inserted_time is stored as a Unix-epoch-seconds string.
    formatUploadTime = (value) => {
        const seconds = Number(value);
        if (!seconds) return "-";
        const date = new Date(seconds * 1000);
        if (isNaN(date.getTime())) return "-";
        return date.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
    };

    handleDelete = async (id) => {
        if (window.confirm("Do you want Delete this Material")) {
            this.deleteRevisionMaterial(id).catch(error => {
                console.log("error", error);
                this.setState({ submitError: error.graphQLErrors.map(x => x.message), loader: 0 });
            });
            this.setState({ loader: 1 })
        }
    }
    deleteRevisionMaterial = async (revisionMaterialId) => {
        await this.props.deleteRevisionMaterial({
            variables: { revisionMaterialId },
            update: (store, { data }) => {
                if (data.deleteRevisionMaterial) {
                    this.getInstituteRevisionMaterial();
                }
            }
        });
    };

    ActionsFun(val, row) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-center">
                <Button variant="link" name="view" className="text-theme" title="View" onClick={() => this.setState({ materialViewModal: true, individualMaterials: [row.individualRowData] })}>
                    <i className="fas fa-eye" />
                </Button>
                <Button variant="link" name="edit" className="text-theme" title="Edit" onClick={() => this.setState({ activeTab: "upload", individualMaterials: [row.individualRowData] })}>
                    <i className="fas fa-edit" />
                </Button>
                <Button variant="link" name="delete" className="text-theme" title="Delete" onClick={() => this.handleDelete(row.individualRowData.id)}>
                    <i className="far fa-trash-alt text-danger" />
                </Button>
            </div>
        )
    }

    tableData(data) {
        return data.map((mapData) => ({
            class: mapData.class_name,
            subject: mapData.subject_name,
            chapter: mapData.chapter_name || "-",
            file_name: mapData.file_name,
            uploaded: this.formatUploadTime(mapData.inserted_time),
            individualRowData: mapData
        }));
    }

    render() {
        if (this.state.initialLoad) {
            return <RevisionMaterialShimmer />;
        }

        const { branches, branchSearch, examSearch, classSearch, subjectSearch } = this.state;

        const branchOptions = branches.map(b => ({ value: b.id, label: b.branch_name }));
        const examOptions = this.examOptions();
        const classOptions = this.classOptionsForBranch(branchSearch);
        const subjectOptions = this.state.classWiseSubjects.length > 0 ? this.state.classWiseSubjects : this.subjectOptions();

        const count = this.state.instituteRevisionMaterialData.length;
        const { activeTab } = this.state;

        return (
            <div style={FIN.pageWrap}>
                <Container fluid className="px-0">
                    <div style={FIN.card}>
                        {/* Tab strip (finance module's nav-tabs pattern) */}
                        <div style={FIN.tabStrip}>
                            <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === "dashboard" ? "active" : ""}`}
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); this.setState({ activeTab: "dashboard" }); }}
                                        style={tabLinkStyle(activeTab === "dashboard")}
                                    >
                                        <i className="fal fa-chart-bar" /> Dashboard
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === "upload" ? "active" : ""}`}
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); this.setState({ activeTab: "upload", individualMaterials: [] }); }}
                                        style={tabLinkStyle(activeTab === "upload")}
                                    >
                                        <i className="fal fa-upload" /> Material Upload
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Content panel */}
                        <div style={FIN.content}>
                        {activeTab === "dashboard" ? (
                            <>
                                {/* Filters */}
                                <Row className="g-3 align-items-end">
                                    {/* No Branch filter — the header (NavbarOne) scopes this page. */}
                                    <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                                        <label style={FIN.label}>Exam</label>
                                        <CheckboxDropdown options={examOptions} value={examSearch} onChange={this.onExamChange} placeholder="Select Exam(s)" />
                                    </Col>
                                    <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                                        <label style={FIN.label}>Class</label>
                                        <CheckboxDropdown options={classOptions} value={classSearch} onChange={this.onClassChange} placeholder="Select Class(es)" />
                                        {this.state.classMultiError ? <span style={FIN.err}>{this.state.classMultiError}</span> : null}
                                    </Col>
                                    <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                                        <label style={FIN.label}>Subject</label>
                                        <CheckboxDropdown options={subjectOptions} value={subjectSearch} onChange={this.onSubjectChange} placeholder="Select Subject(s)" />
                                        {this.state.subjectMultiError ? <span style={FIN.err}>{this.state.subjectMultiError}</span> : null}
                                    </Col>
                                </Row>

                                {/* Content */}
                                <div style={{ marginTop: 20 }}>
                                    {this.state.loader == 1 ? (
                                        <RevisionTableShimmer rows={6} cols={7} />
                                    ) : count > 0 ? (
                                        <CardLessDataTableWithSearch
                                            parentData={this.tableData(this.state.instituteRevisionMaterialData)}
                                            particlecolumns={this.articlecolumns}
                                            name="hostel_attendance"
                                            leftContent={
                                                <span style={FIN.countBadge}>{count} Material{count === 1 ? "" : "s"} Found</span>
                                            }
                                        />
                                    ) : this.state.noDataError != "" ? (
                                        <div className="text-center p-5 text-muted bg-white rounded shadow-sm border">
                                            <i className="fa fa-inbox fa-3x d-block mb-3 text-light" />
                                            <p>{this.state.noDataError}</p>
                                        </div>
                                    ) : null}
                                </div>
                            </>
                        ) : (
                            <RevisionMaterialUploadModal
                                globals={this.props.globals}
                                getEmployees={this.props.getEmployees}
                                branches={this.state.branches}
                                getClasses={this.state.getClasses}
                                stateData={this.state}
                                onDone={() => this.setState({ activeTab: "dashboard" }, () => this.getInstituteRevisionMaterial())}
                            />
                        )}
                        </div>
                    </div>
                </Container>

                <MaterialPDFViewModal
                    stateData={this.state}
                    show={this.state.materialViewModal}
                    onHide={() => this.setState({ materialViewModal: false })}
                />
            </div>
        )
    }
}
export default withRouter(withApollo(
    graphql(DELETE_REVISION_MATERIAL, {
        name: "deleteRevisionMaterial"
    })(RevisionMaterialSection)));
